import { useBreadcrumb } from "contexts/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCookieContext } from "../../../contexts";
import ApplyPublicationButton from "./ApplyPublicationButton";
import CourseOrderStatisticsChart from "./CourseOrderStatisticsChart";
import ScientificPublishingStatisticsChart from "./ScientificPublishingStatisticsChart";
import TaskStatisticsTiles from "./TaskStatisticsTiles";
import ScientificPublishingCountTiles from "./ScientificPublishingCountTiles";

function DashboardView() {
  const { setBreadcrumbs } = useBreadcrumb();
  const { userSession } = useCookieContext();
  const { t } = useTranslation();



  // Check if user is admin for navigation purposes
  const isAdmin = userSession?.roles?.includes("PublishingAdmin") ||
                  userSession?.roles?.includes("SuperAdmin");

    useEffect(() => {
        console.log("isAdmin", isAdmin);
    }, [isAdmin]);

  useEffect(() => {
    setBreadcrumbs([
      {
        localizationKey: "dashboard",
        path: "/home/dashboard",
        menuItemId: "dashboard",
      },
    ]);
  }, []);

  return (
      <>
          <div className="container-fluid py-4">
            {/* Task Statistics Section */}
            <div className="mb-4">
              <h4 className="mb-3 fw-bold" style={{ color: '#2c3e50' }}>
                {t("Dashboard:taskStatistics")}
              </h4>
              <TaskStatisticsTiles useMyStats={!isAdmin} />
            </div>

            {/* Scientific Publishing Count Statistics Section */}
            <div className="mb-4">
              <ScientificPublishingCountTiles useMyStats={!isAdmin} isAdmin={isAdmin} />
            </div>

            {/* Course Order & Scientific Publishing Statistics Section */}
            <div className="mb-4">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <CourseOrderStatisticsChart useMyStats={!isAdmin} />
                </div>
                <div className="col-md-6 mb-4">
                  <ScientificPublishingStatisticsChart useMyStats={!isAdmin} />
                </div>
              </div>
            </div>

            {/* Apply Publication Order Button */}
            <ApplyPublicationButton />
          </div>
      </>
  )
}

export default DashboardView;
